<template>
  <v-container v-if="pricesLoadedByItemId == true">
    <div class="text-center background text border pt-2">
      <div></div>
      <div class="d-flex justify-content-around">
        <img :src="images.logo" style="width: 80px" alt="" />
        <div>
          <h1 class="mt-5">Sell offers</h1>
          <h4>{{ itemSearched }}</h4>
        </div>
        <img :src="images.femaleLogo" style="width: 80px" alt="" />

      </div>
      <v-container class="text-center">
        <v-data-table
          class="default-text"
          :headers="headers"
          :items="itemPricesByItemId"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          hide-default-footer
          :items-per-page="1000"
        >
          <template v-slot:[`item`]="{ item }">
            <tr
              class="myrow text-left"
              @click="
                getHistory({
                  itemName: itemSearched,
                  world: item.world,
                  time: 0,
                })
              "
            >
              <td class="col-4 text-left">
                <p>{{ item.world }}</p>
              </td>
              <td class="col-4 text-left">
                <p>{{ item.minSellValue.toLocaleString('en', {useGrouping:true}) }} gp</p>
              </td>
              <td class="col-2 text-left">
                {{item.tcPrice}}
                tc
              </td>
              <td class="col-2 text-left">
                {{ item.change }}
                %
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import images from "@/assets/images";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      images: images,
      search: "",
    };
  },
  computed: {
    ...mapState([
      "tibiaCoinPrice",
      "pricesLoadedByItemId",
      "itemPricesByItemId",
      "itemSearched",
    ]),
    headers() {
      return [
        { text: "World", value: "world", class: "warning--text" },
        { text: "Value", value: "minSellValue", class: "warning--text" },
        { text: "Value tc", value: "tcPrice", class: "warning--text" },
        { text: "Change", value: "change", class: "warning--text" },
      ];
    },
  },
  methods: {
    ...mapMutations(["getHistory"]),
    test(name) {
      console.log(name);
    },
    customRowClass() {
      return "background";
    },
    filterOnlyCapsText(value, search, item) {
      item;
      const upperCasedSearch = search.toUpperCase();
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLocaleUpperCase().indexOf(upperCasedSearch) !== -1
      );
    },
  },
};
</script>

<style scoped>
.myrow:hover {
  cursor: pointer;
  background-color: rgba(12, 25, 32, 0.25) !important;
}
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147) !important;
}

.default-text {
  font-family: initial !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: rgb(238, 195, 147) !important;
}

.border {
  border-radius: 10px;
}
</style>